import React, { useState, useEffect } from 'react';
import { IconButton, InputAdornment, FormControl } from '@mui/material';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { StyledOutlinedInput, StyledSearchIcon } from './style';

const DevicesFilter = props => {
  const { projectId, addMode, setFilter, changePage } = props;
  const [value, setValue] = useState('');
  const dispatch = useDispatch();
  const { filter, page } = useSelector(s => s.projectUsersPopup, shallowEqual);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!value.length && filter?.groupFilter === 'type') return;
      const newValue = value?.length > 1 ? value : null;
      if (filter !== newValue) {
        if (page !== 1) {
          dispatch(changePage(1, projectId, false, false, null));
        }
        dispatch(setFilter(newValue, projectId, addMode, null, null));
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [
    dispatch,
    value,
    filter,
    projectId,
    page,
    addMode,
    setFilter,
    changePage
  ]);

  const handleFilterChange = event => {
    const { value: newValue } = event.target;
    setValue(newValue);
  };

  const handleClearButtonClick = () => {
    setValue('');
  };

  return (
    <FormControl variant="outlined">
      <StyledOutlinedInput
        endAdornment={value ?
          <InputAdornment position="end">
            <IconButton size="small" onClick={handleClearButtonClick}>
              <ClearRoundedIcon />
            </IconButton>
          </InputAdornment> : null}
        startAdornment={
          <InputAdornment position="start">
            <StyledSearchIcon />
          </InputAdornment>
        }
        inputProps={{
          'aria-label': 'search'
        }}
        value={value}
        placeholder="User search"
        onChange={handleFilterChange}
      />
    </FormControl>
  );
};

export default DevicesFilter;
